import type { NotificationToRender } from 'common/models';
import FlexRow from 'components/FlexRow/FlexRow';
import dayjs from 'dayjs';
import { getNotificationLink, isNotificationLinkActive } from 'helpers/notificationsHelper';
import { getNow } from 'helpers/timeHelpers';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  notification: NotificationToRender;
  onClose?: () => void;
}

export const NotificationItem: React.FC<Props> = (props): React.ReactElement => {
  const { notification, onClose } = props;

  const navigate = useNavigate();

  const isLinkActive = isNotificationLinkActive(notification.type);

  const getTransformedTime = () => {
    const eventTime = dayjs(notification.createdAt);

    if (getNow().diff(eventTime, 'days') > 14) {
      return eventTime.format('LL');
    }

    return eventTime.fromNow();
  };

  return (
    <div
      className={`NotificationItem ${!notification.seenAt ? 'unread' : ''} ${
        isLinkActive ? 'clickable' : ''
      }`}
      onClick={() => {
        isLinkActive && onClose && onClose();
        isLinkActive && getNotificationLink(notification, navigate);
      }}
    >
      <div className="NotificationItem_content">
        <FlexRow noMargin>
          <div className="NotificationItem_title">{notification.title}</div>
          {notification.createdAt && (
            <div className="NotificationItem_time">{getTransformedTime()}</div>
          )}
        </FlexRow>
        <div className="NotificationItem_description">{notification.message}</div>
      </div>
    </div>
  );
};

export default NotificationItem;
